import { fetchUserConnections } from "@/services/apis/userConnectionsApi";

import { manageFollowState } from "../../services/apis/userConnectionsApi";

export default {
  async fetchConnections({ commit }, params) {
    const data = await fetchUserConnections(params);

    if (data) {
      commit("setGenericCollection", {
        params: params,
        data: data
      });

      return data;
    } else {
      console.error(`Failed to fetch ${params.type} connections.`);
    }
  },

  // async fetchFollowing({ commit }, payload) {
  //   const response = await this.$axios.get("/following");
  //   commit("setFollowing", response.data);
  // },
  // async follow({ commit }, payload) {
  //   await this.$axios.post("/follow", payload);
  //   commit("addFollow", payload);
  // },

  async setNextPagonationElements({ commit }, payload) {
    const params = {
      type: payload.tab,
      userId: payload.userId,
      offset: payload.offset,
      limit: payload.limit,
      // lastId: payload.lastId,
      only: payload.only
    };

    let response = await fetchUserConnections(params);

    if (response && response.results.length > 0) {
      commit("addToGenericCollection", {
        collection: payload.tab,
        data: response.results,
      });
    }

    if (response.statusCode) {
      authErrorHandler(response.statusCode);
    }
    return response.results;
  },

  addConnectionsCollection({ commit }, payload) {
    commit("addToGenericCollection", payload);
  },

  async manageConnection({ commit }, payload) {
    const response = await manageFollowState(
      payload.userId,
      payload.type,
      payload.status
    );
    if (response) {
      return true;
    } else {
      return false;
    }
  },
};
